<template>
  <span
    @click="callPhone"
    class="cursor-pointer data-content"
    data-content="+45 60 82 00 06"
  ></span>
</template>

<script>
export default {
  name: "LinkPhone",
  methods: {
    callPhone() {
      location.href = "tel:+4560820006";
    },
  },
};
</script>
